var _style, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestingPerformance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TESTING-PERFORMANCE",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#2458A6;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#2458A6;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#F2644B;stroke-width:11;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#F2644B;stroke-width:9;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st4{fill:#F2644B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.1,221.7H36.4c-0.6,0-1.1-0.5-1.1-1.1V66.1c0-0.6,0.5-1.1,1.1-1.1h198.1c0.6,0,1.1,0.5,1.1,1.1V137"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 37.8,
    y1: 195.6,
    x2: 213.1,
    y2: 195.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 214.7,
    y: 140.9,
    className: "st0",
    width: 52.6,
    height: 98.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 214.7,
    y1: 221.3,
    x2: 260.9,
    y2: 221.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 132.1,
    cy: 132,
    r: 36.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.4,125.6c0-8.4,7.8-15.3,17.4-15.3c9.6,0,17.4,6.8,17.4,15.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.1,
    y1: 127.6,
    x2: 132.1,
    y2: 142.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 132.1,
    cy: 146.6,
    r: 4.4
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M251.5,180.7h-1.7c-0.4,0-0.8-0.3-0.9-0.7c-0.3-0.8-0.7-1.5-1.2-2.1c-0.3-0.3-0.3-0.8-0.1-1.1l0.8-1.5 c0.3-0.5,0.1-1.1-0.4-1.4l-2.6-1.5c-0.5-0.3-1.1-0.1-1.4,0.4l-0.8,1.4c-0.2,0.3-0.6,0.6-1,0.5c-0.4-0.1-0.8-0.1-1.3-0.1 c-0.4,0-0.9,0-1.3,0.1c-0.4,0.1-0.8-0.1-1-0.5l-0.8-1.4c-0.3-0.5-0.9-0.6-1.4-0.4l-2.6,1.5c-0.5,0.3-0.6,0.9-0.4,1.4l0.8,1.5 c0.2,0.4,0.2,0.8-0.1,1.1c-0.5,0.6-0.9,1.3-1.2,2.1c-0.2,0.4-0.5,0.7-0.9,0.7h-1.7c-0.6,0-1,0.4-1,1v3c0,0.6,0.4,1,1,1h1.7 c0.4,0,0.8,0.3,0.9,0.7c0.3,0.8,0.7,1.5,1.2,2.1c0.3,0.3,0.3,0.8,0.1,1.1l-0.8,1.5c-0.3,0.5-0.1,1.1,0.4,1.4l2.6,1.5 c0.5,0.3,1.1,0.1,1.4-0.4l0.8-1.4c0.2-0.3,0.6-0.6,1-0.5c0.4,0.1,0.8,0.1,1.3,0.1c0.4,0,0.9,0,1.3-0.1c0.4-0.1,0.8,0.1,1,0.5 l0.8,1.4c0.3,0.5,0.9,0.6,1.4,0.4l2.6-1.5c0.5-0.3,0.6-0.9,0.4-1.4l-0.8-1.5c-0.2-0.4-0.2-0.8,0.1-1.1c0.5-0.6,0.9-1.3,1.2-2.1 c0.2-0.4,0.5-0.7,0.9-0.7h1.7c0.6,0,1-0.4,1-1v-3C252.5,181.1,252.1,180.7,251.5,180.7z M240.8,185.8c-3.9,0-3.9-6,0-6 C244.7,179.8,244.7,185.8,240.8,185.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestingPerformance);
export default __webpack_public_path__ + "static/media/testing-performance.17be89e65d042a4d3ed347edab1a53c1.svg";
export { ForwardRef as ReactComponent };